import React from 'react';
import styles from '../RateView.module.css';
import SelectInstance from '../../../modal/selectinstance/SelectInstance';
import { getCurrentResource } from '../../../util/tools';
import { performApiRequest, MASTER_LOAD_REF_API_URL } from '../../../util/restapi';
import FilterLabel from './FilterLabel';

import searchIcon from '../../../assets/icons/png24x24/Search.png';
import deleteIcon from '../../../assets/icons/png24x24/Delete.png';

class FilterObjectRef extends React.Component {

	constructor(props) {
		super(props);
		this.resource = getCurrentResource().components.rateview.filter.FilterObjectRef;		
		let rateView = props.rateView;

		this.selectInstanceRvContext = {
			rateView: null,
			form: props.filter.selectObjectRefFormId,
			formTitle: props.filter.selectObjectRefFormTitle, 
			data: null
		};

		let filterValue = null; // ObjectRef
		if( rateView.rvContext && rateView.rvContext.filtersInitData ) {
			for(let f of rateView.rvContext.filtersInitData) {
				if( f.predicateId == props.filter.predicateId ) {
					filterValue = f.value;
					break;
				}
			}
		}

		this.state = {
			value: filterValue,
			isSelectValueModalOpen: false
		}
		if( filterValue )
			this.updateQueryByValue( filterValue );
	}
	componentDidMount() {
		let rateView = this.props.rateView;
		rateView.registerFilter( this );
	}
	componentWillUnmount() {
		let rateView = this.props.rateView;
		rateView.unregisterFilter( this );
	}

	clearFilter = () => {
		this.props.rateView.clearQueryFilter( this.props.filter.predicateId )
		this.setState({value: null});
	}
	
	selectValue = () => {
		this.setState({ isSelectValueModalOpen: true });
	}
	onValueSelected = async (rows) => {
		this.props.rateView.clearData();
		let request = {
			id: rows[0]
		}
		let response = await performApiRequest(MASTER_LOAD_REF_API_URL, request);
		if( ! response.success ) {
			this.props.rateView.props.app.showResponse( response );
			this.closeSelectValue();
			return;
		}
		let objectRef = response.data;
		this.setState({value: objectRef});
		this.closeSelectValue();
		this.updateQueryByValue( objectRef );
	}
	closeSelectValue = () => {
		this.setState({ isSelectValueModalOpen: false });
	}

	updateQueryByValue = (value) => {
		let filterValue = ( value ) ? value.id : '';
		let q = this.props.rateView.query;
		let indexFilter = -1;
		for(let i=0; i < q.listPredicate.length; i++) {
			if( q.listPredicate[i].predicateId == this.props.filter.predicateId ) {
				indexFilter = i;
				break;
			}
		}
		if( indexFilter < 0 ) {
			q.listPredicate.push( {
				predicateId: this.props.filter.predicateId,
				conditionId: this.props.filter.conditionId,
				value: filterValue
			} );
		} else {
			q.listPredicate[indexFilter].value = filterValue;
		}
	}

	fetchProfile = () => {
		if( this.state.value )
			return {filterId: this.props.filter.predicateId, value: this.state.value};
		else
			return null;
	}
	applyProfile = (profile) => {
		this.updateQueryByValue( profile.value );
		this.setState({value: profile.value});
	}
	
	render() {
		let filter = this.props.filter;
		let card = ( this.state.value ) ? this.state.value.card : '';
		return (
			<div className={styles.divFilter}>
				<FilterLabel title={filter.title} tooltip={filter.tooltip} />
				<div className={styles.divFilterObjectRef}>
					<input className={styles.inputObjectRefCard} type='text' value={card} readOnly={true} />
					<button 
						className={styles.buttonObjectRefSelect} 
						type='button' onClick={this.selectValue}
						title={this.props.filter.selectObjectRefButtonTooltip}
					>
						<img src={searchIcon} />
					</button>
					<button 
						className={styles.buttonObjectRefClear} 
						type={'button'} onClick={this.clearFilter}
						title={this.resource.buttonClearTooltip}
					>
						<img src={deleteIcon} />
					</button>
				</div>
				<SelectInstance 
					isModalOpen={this.state.isSelectValueModalOpen} 
					closeModal={this.closeSelectValue}
					title={this.props.filter.selectObjectRefFormTitle}
					onInstanceSelected={this.onValueSelected}
					rvContext = {this.selectInstanceRvContext}
				/>
			</div>
		);
	}	

}

export default FilterObjectRef;
